import { render } from "./YuebaoDetial.vue?vue&type=template&id=638e6472&scoped=true"
import script from "./YuebaoDetial.vue?vue&type=script&lang=js"
export * from "./YuebaoDetial.vue?vue&type=script&lang=js"

import "./YuebaoDetial.vue?vue&type=style&index=0&id=638e6472&scoped=true&lang=stylus"

import exportComponent from "D:\\GameProject\\h5yaoji\\H5-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638e6472"]])

export default __exports__